import { z } from 'zod'

export const futureInternshipSearchSchema = z.object({
  search: z.string().catch(''),
  categories: z.array(z.coerce.number().int().positive()).catch([]),
  page: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(25),
  sortBy: z.enum(['start', 'end', 'program', 'eduOrg']).catch('start'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type FutureInternshipSearch = z.infer<typeof futureInternshipSearchSchema>
export const defaultFutureInternshipSearch = futureInternshipSearchSchema.parse({})
